import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconStoreClient from '@/icons/StoreClient.svg';

export const RequestClaimedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'request_claimed'>;
}) => {
  const storeCreatorName = activity.storeCreator.name;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      icon={<IconStoreClient />}
      type="secondary"
      message={
        <BaseActivityText>
          <Trans id="activities.request_claimed.message">
            <strong>{storeCreatorName}</strong> took the request in charge
          </Trans>
        </BaseActivityText>
      }
    />
  );
};
